<!--
 * @Descripttion: 商品详情
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-10-28 12:05:31
-->

<template>
  <div id="details" v-if="productDetails">
    <!-- 头部 -->
    <div class="page-header">
      <div class="title">
        <p>{{ productDetails.name }}</p>
      </div>
    </div>
    <!-- 头部END -->

    <!-- 主要内容 -->
    <div class="details-main">
      <!-- 左侧商品轮播图 -->
      <div class="details-block">
        <el-carousel height="560px" v-if="productPictures.length > 1">
          <el-carousel-item v-for="item in productPictures" :key="item.id">
            <img style="height: 560px;" v-lazy="item.img_path" />
          </el-carousel-item>
        </el-carousel>
        <div v-if="productPictures.length == 1">
          <img style="height: 560px;" :src="productPictures[0].img_path" />
        </div>
      </div>
      <!-- 左侧商品轮播图END -->

      <!-- 右侧内容区 -->
      <div class="details-content">
        <h1 class="name">{{ productDetails.name }}</h1>
        <li class="view">
          <i class="el-icon-view"></i>
          {{ productDetails.view }}
        </li>
        <p class="intro">{{ productDetails.info }}</p>
        <p class="store">self-operated</p>
        <div class="price">
          <span>{{ productDetails.discount_price }}₹</span>
          <span
            v-show="productDetails.price != productDetails.discount_price"
            class="del"
          >{{ productDetails.price }}₹</span>
           <p class="intro">Tax included. Free shipping</p>
        </div>
        <!-- 尺码选择 -->
        <div class="size-section" v-if="productDetails.sizes && productDetails.sizes.length > 0">
          <div class="size-header">
            <span class="size-label">Size:</span>
            <el-button
              v-if="productDetails.size_chart_img"
              type="text"
              class="size-chart-link"
              @click="showSizeChart = true"
            >
              <i class="el-icon-view"></i> Size Chart
            </el-button>
          </div>
          <div class="size-options">
            <span
              v-for="size in productDetails.sizes"
              :key="size"
              class="size-option"
              :class="{ active: selectedSize === size }"
              @click="selectedSize = size"
            >{{ size }}</span>
          </div>
        </div>
        <div class="pro-list">
          <span class="pro-name">{{ productDetails.name }}</span>
          <span v-if="selectedSize" class="pro-size">Size: {{ selectedSize }}</span>
          <span class="pro-price">
            <span>{{ productDetails.discount_price }}₹</span>
            <span
              v-show="productDetails.price != productDetails.discount_price"
              class="pro-del"
            >{{ productDetails.price }}₹</span>
          </span>
          <p class="price-sum">Total : {{ productDetails.discount_price }}₹</p>
          <p class="intro">Tax included. Free shipping</p>
        </div>
        <!-- 商品属性展示 -->
        <div class="pro-attr" v-if="productProperties">
          <div class="attr-item" v-for="(val, key) in productProperties" :key="key">
            <span class="attr-key">{{ key }}:</span>
            <span class="attr-val">{{ val }}</span>
          </div>
        </div>
        <!-- Size选择器 -->
        <div class="size-select" v-if="showSize">
          <span class="size-label">Size:</span>
          <el-radio-group v-model="selectedSize">
            <el-radio-button v-for="s in sizeOptions" :key="s" :label="s">{{ s }}</el-radio-button>
          </el-radio-group>
        </div>
        <!-- 内容区底部按钮 -->
        <div class="button">
          <el-button class="shop-cart" :disabled="dis" @click="addShoppingCart">Add to Cart</el-button>
          <el-button class="like" @click="addFavorite">Like</el-button>
        </div>
        <!-- 内容区底部按钮END -->
        <div class="pro-policy">
          <ul>
            <li>
              <i class="el-icon-circle-check"></i>
              Self operated Mall
            </li>
            <li>
              <i class="el-icon-circle-check"></i>
              Fast delivery
            </li>
            <li>
              <i class="el-icon-circle-check"></i>
              7-day no reason return policy
            </li>
            <li>
              <i class="el-icon-circle-check"></i>
              7-day price protection
            </li>
          </ul>
        </div>
      </div>
      <!-- 右侧内容区END -->
    </div>
    <!-- 主要内容END -->
    <div class="product-img" v-for="item in imgs" :key="item.id">
      <img v-lazy="item.img_path" />
    </div>
    <!-- 尺码表弹窗 -->
    <el-dialog
      title="Size Chart"
      :visible.sync="showSizeChart"
      width="700px"
      center
    >
      <div class="size-chart-container" v-if="productDetails.size_chart_img">
        <img
          :src="productDetails.size_chart_img"
          alt="Size Chart"
          style="width: 100%;"
        />
      </div>
      <!-- 默认尺码表（当没有图片尺码表但有尺码数据时） -->
      <div class="size-chart-table" v-else-if="productDetails.sizes && productDetails.sizes.length > 0">
        <table>
          <thead>
            <tr>
              <th>Size</th>
              <th>Bust (in)</th>
              <th>Waist (in)</th>
              <th>Hip (in)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="size in productDetails.sizes" :key="size">
              <td><strong>{{ size }}</strong></td>
              <td>{{ getSizeMeasurements(size).bust || '-' }}</td>
              <td>{{ getSizeMeasurements(size).waist || '-' }}</td>
              <td>{{ getSizeMeasurements(size).hip || '-' }}</td>
            </tr>
          </tbody>
        </table>
        <p class="size-chart-note">* Measurements are in inches. Please allow slight variations.</p>
      </div>
      <div v-else class="no-size-chart">
        <p>No size chart available for this product.</p>
      </div>
    </el-dialog>
  </div>
  <div class="not-found" v-else>Unable to find the product
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import * as productsAPI from '@/api/products/'
import * as imgsAPI from '@/api/img/'
import * as favoritesAPI from '@/api/favorites/'
import * as cartsAPI from '@/api/carts/'
export default {
  data() {
    return {
      dis: false, // 控制”加入购物车按钮是否可用”
      productID: 0, // 商品id
      productDetails: '', // 商品详细信息
      productPictures: '', // 商品图片
      imgs: '', //商品概述图片
      infoImgs: '',
      paramImgs: '',
      select: 0,
      selectedSize: 'M',
      sizeOptions: ['S', 'M', 'L', 'XL', 'XXL']
    }
  },
  // 通过路由获取商品id
  activated() {
    if (this.$route.query.productID != undefined) {
      this.productID = this.$route.query.productID
    }
  },
  watch: {
    // 监听商品id的变化，请求后端获取商品数据
    productID: function() {
      this.load()
      //this.getDetailsPicture(val);
    }
  },
  methods: {
    ...mapActions(['unshiftShoppingCart', 'addShoppingCartNum']),
    // 获取商品详细信息
    load() {
      this.selectedSize = ''
      this.showSizeChart = false
      productsAPI.showProduct(this.productID).then(res => {
        this.productDetails = res.data
      })
      productsAPI.showPictures(this.productID).then(res => {
        this.productPictures = res.data
      })
      imgsAPI.showInfoImgs(this.productID).then(res => {
        this.infoImgs = res.data
        this.imgs = this.infoImgs
      })
      imgsAPI.showParamImgs(this.productID).then(res => {
        this.paramImgs = res.data
      })
    },
    goInfo() {
      this.showInfoImgs()
      document.getElementById('product-select').scrollIntoView()
    },
    goParam() {
      this.showParamImgs()
      document.getElementById('product-select').scrollIntoView()
    },
    showInfoImgs() {
      this.select = 0
      this.imgs = this.infoImgs
    },
    showParamImgs() {
      this.select = 1
      this.imgs = this.paramImgs
    },
    // 加入购物车
    addShoppingCart() {
      // 判断是否登录,没有登录则显示登录组件
      if (!this.$store.getters.getUser) {
        this.$router.push({ name: 'Login' })
        return
      }
      // 如果商品有尺码选项，必须选择一个尺码
      if (this.productDetails.sizes && this.productDetails.sizes.length > 0 && !this.selectedSize) {
        this.notifyError('Please select a size')
        return
      }
      var form = {
        user_id: this.$store.getters.getUser.id,
        product_id: Number(this.productID),
        size: this.showSize ? this.selectedSize : ''
      }
      cartsAPI
        .postCart(form)
        .then(res => {
          switch (res.status) {
            case 200:
              //新加入购物车成功
              this.unshiftShoppingCart(res.data)
              this.notifySucceed('Add shopping cart successfully')
              break
            case 201:
              // 该商品已经在购物车，数量+1
              this.addShoppingCartNum(this.productID)
              this.notifySucceed('The product is already in the shopping cart, quantity+1')
              break
            case 202:
              // 商品数量达到限购数量
              this.dis = true
              this.notifyError('The product has reached the purchase limit quantity', res.msg)
              break
            case 20001:
              //token过期，需要重新登录
              this.loginExpired(res.msg)
              break
            default:
              this.notifyError('Adding shopping cart failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Adding shopping cart failed', err)
        })
    },
    addFavorite() {
      // 判断是否登录,没有登录则显示登录组件
      if (!this.$store.getters.getUser) {
        this.$router.push({ name: 'Login' })
        return
      }
      var form = {
        user_id: this.$store.getters.getUser.id,
        product_id: Number(this.productID)
      }
      favoritesAPI
        .postFavorite(form)
        .then(res => {
          if (res.status === 200) {
            this.notifySucceed('Favorite added successfully')
          } else if (res.status === 20001) {
            //token过期，需要重新登录
            this.loginExpired(res.msg)
          } else {
            this.notifyError('Add Favorite Failed', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Add Favorite Failed', err)
        })
    },
    // 获取尺码对应的测量数据（用于默认尺码表）
    getSizeMeasurements(size) {
      // 标准印度女士服装尺码对照表（英寸）
      const sizeChart = {
        'XS': { bust: '32-33', waist: '26-27', hip: '34-35' },
        'S':  { bust: '34-35', waist: '28-29', hip: '36-37' },
        'M':  { bust: '36-37', waist: '30-31', hip: '38-39' },
        'L':  { bust: '38-39', waist: '32-33', hip: '40-41' },
        'XL': { bust: '40-41', waist: '34-35', hip: '42-43' },
        'XXL':{ bust: '42-43', waist: '36-37', hip: '44-45' },
        '3XL':{ bust: '44-45', waist: '38-39', hip: '46-47' },
        '4XL':{ bust: '46-47', waist: '40-41', hip: '48-49' },
        '5XL':{ bust: '48-49', waist: '42-43', hip: '50-51' },
        // 自由尺码（Free Size）- 适合无具体尺码的产品如纱丽
        'Free Size': { bust: 'Fits All', waist: 'Fits All', hip: 'Fits All' }
      }
      return sizeChart[size] || {}
    }
  },
  computed: {
    productProperties() {
      if (!this.productDetails || !this.productDetails.properties) return null
      try {
        return JSON.parse(this.productDetails.properties)
      } catch (e) {
        return null
      }
    },
    showSize() {
      if (!this.productDetails || !this.productDetails.name) return true
      const name = this.productDetails.name.toLowerCase()
      const noSizeKeywords = [
        'sunglass', 'sunglasses', 'hat', 'cap', 'scarf', 'stole', 'hijab',
        'dupatta', 'socks', 'nakab', 'belt', 'wallet', 'bag', 'jewel',
        'necklace', 'earring', 'bangle', 'bracelet', 'watch'
      ]
      return !noSizeKeywords.some(k => name.includes(k))
    }
  },
  beforeRouteEnter(to, from, next) {
    // 添加背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#ffffff')
    next()
  },
  beforeRouteLeave(to, from, next) {
    // 去除背景色
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#f5f5f5')
    next()
  }
}
</script>
<style scoped>
/* 头部CSS */
#details .page-header {
  height: 64px;
  z-index: 4;
  background: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  -webkit-box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.07);
  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.07);
}
#details .page-header .title {
  width: 1225px;
  height: 64px;
  line-height: 64px;
  font-size: 18px;
  font-weight: 400;
  color: #212121;
  margin: 0 auto;
}
#details .page-header .title p {
  float: left;
}
#details .page-header .title .list {
  height: 64px;
  float: right;
  display: flex;
  align-items: center;
}
#details .page-header .title .list .select {
  float: left;
  margin-left: 20px;
}

#details .page-header .title .list .select .list-select {
  font-size: 14px;
  color: #616161;
}
#details .page-header .title .list .select .list-select:hover {
  font-size: 14px;
  color: #E8A87C;
}
#details .page-header .title .list .cut {
  font-size: 17px;
  color: #c9c7c7;
  margin-left: 20px;
}
/* 头部CSS END */

/* 主要内容CSS */
#details .details-main {
  width: 1225px;
  min-height: 640px;
  padding-top: 30px;
  margin: 0 auto;
  padding-bottom: 30px;
  border-bottom: 1px solid #e0e0e0;
}
#details .details-main .details-block {
  float: left;
  width: 560px;
  height: 560px;
}
#details .el-carousel .el-carousel__indicator .el-carousel__button {
  background-color: rgba(163, 163, 163, 0.8);
}
#details .details-main .details-content {
  float: left;
  margin-left: 25px;
  width: 640px;
}

#details .details-main .details-content .name {
  line-height: 30px;
  font-size: 24px;
  font-weight: normal;
  color: #212121;
  display: inline;
}

#details .details-main .details-content .view {
  color: #b0b0b0;
  float: right;
  padding-top: 5px;
  font-size: 18px;
}

#details .details-main .details-content .intro {
  color: #b0b0b0;
  padding-top: 10px;
}
#details .details-main .details-content .store {
  color: #E8A87C;
  padding-top: 10px;
}
#details .details-main .details-content .price {
  display: block;
  font-size: 18px;
  color: #E8A87C;
  border-bottom: 1px solid #e0e0e0;
  padding: 25px 0 25px;
}
#details .details-main .details-content .price .del {
  font-size: 14px;
  margin-left: 10px;
  color: #b0b0b0;
  text-decoration: line-through;
}
/* 尺码选择 */
#details .details-main .details-content .size-section {
  padding: 20px 0;
  border-bottom: 1px solid #e0e0e0;
}
#details .details-main .details-content .size-section .size-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
#details .details-main .details-content .size-section .size-label {
  font-size: 16px;
  font-weight: 500;
  color: #212121;
}
#details .details-main .details-content .size-section .size-chart-link {
  font-size: 14px;
  color: #E8A87C;
  padding: 0;
}
#details .details-main .details-content .size-section .size-chart-link:hover {
  color: #D4737A;
  text-decoration: underline;
}
#details .details-main .details-content .size-section .size-options {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
#details .details-main .details-content .size-section .size-option {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 40px;
  border: 1.5px solid #d0d0d0;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #424242;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fff;
}
#details .details-main .details-content .size-section .size-option:hover {
  border-color: #E8A87C;
  color: #E8A87C;
}
#details .details-main .details-content .size-section .size-option.active {
  background: #E8A87C;
  border-color: #E8A87C;
  color: #ffffff;
}
/* 尺码表弹窗 */
.size-chart-table table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 16px;
}
.size-chart-table th,
.size-chart-table td {
  padding: 12px 16px;
  text-align: center;
  border: 1px solid #e0e0e0;
  font-size: 14px;
}
.size-chart-table th {
  background: #f9f9f9;
  color: #424242;
  font-weight: 600;
}
.size-chart-table td {
  color: #616161;
}
.size-chart-note {
  font-size: 12px;
  color: #9B9B9B;
  text-align: center;
  font-style: italic;
}
.no-size-chart {
  text-align: center;
  padding: 40px 0;
  color: #9B9B9B;
}
/* 已选尺码显示 */
.pro-size {
  display: block;
  color: #E8A87C;
  font-size: 14px;
  font-weight: 500;
  margin-top: 4px;
}
#details .details-main .details-content .pro-list {
  background: #f9f9f9;
  padding: 30px 60px;
  margin: 50px 0 50px;
}
#details .details-main .details-content .pro-list span {
  line-height: 30px;
  color: #616161;
}
#details .details-main .details-content .pro-list .pro-price {
  float: right;
}
#details .details-main .details-content .pro-list .pro-price .pro-del {
  margin-left: 10px;
  text-decoration: line-through;
}
#details .details-main .details-content .pro-list .price-sum {
  color: #E8A87C;
  font-size: 24px;
  padding-top: 20px;
}
/* 商品属性CSS */
#details .details-main .details-content .pro-attr {
  margin: 20px 0;
  padding: 15px;
  background: #f9f9f9;
  border-radius: 8px;
}
#details .details-main .details-content .pro-attr .attr-item {
  display: flex;
  line-height: 28px;
  font-size: 14px;
}
#details .details-main .details-content .pro-attr .attr-key {
  color: #616161;
  min-width: 100px;
}
#details .details-main .details-content .pro-attr .attr-val {
  color: #E8A87C;
  font-weight: 500;
}
/* Size选择器CSS */
#details .details-main .details-content .size-select {
  margin: 20px 0;
  display: flex;
  align-items: center;
}
#details .details-main .details-content .size-select .size-label {
  font-size: 14px;
  color: #616161;
  margin-right: 15px;
}
#details .details-main .details-content .size-select .el-radio-button {
  margin-right: 0;
}
#details .details-main .details-content .size-select .el-radio-button >>> .el-radio-button__inner {
  border-radius: 0;
  border-left: 1px solid #dcdfe6;
}
#details .details-main .details-content .size-select .el-radio-button:first-child >>> .el-radio-button__inner {
  border-radius: 4px 0 0 4px;
}
#details .details-main .details-content .size-select .el-radio-button:last-child >>> .el-radio-button__inner {
  border-radius: 0 4px 4px 0;
}
#details .details-main .details-content .size-select .el-radio-button.is-active >>> .el-radio-button__inner {
  background-color: #E8A87C;
  border-color: #E8A87C;
}
#details .details-main .details-content .button {
  height: 55px;
  margin: 10px 0 20px 0;
}
#details .details-main .details-content .button .el-button {
  float: left;
  height: 55px;
  font-size: 16px;
  color: #fff;
  border: none;
  text-align: center;
}
#details .details-main .details-content .button .shop-cart {
  width: 340px;
  background-color: #E8A87C;
}
#details .details-main .details-content .button .shop-cart:hover {
  background-color: #D4737A;
}

#details .details-main .details-content .button .like {
  width: 260px;
  margin-left: 40px;
  background-color: #b0b0b0;
}
#details .details-main .details-content .button .like:hover {
  background-color: #757575;
}
#details .details-main .details-content .pro-policy li {
  float: left;
  margin-right: 20px;
  color: #b0b0b0;
}
#details .details-main .details-content .pro-policy {
  margin-bottom: 24px;
  overflow: hidden;
}
/* 主要内容CSS END */

/*商品概述&参数*/
#details .product-select {
  width: 300px;
  margin: 0 auto;
  height: 80px;
  display: flex;
  align-items: center;
}
#details .product-select .notSelect {
  font-size: 19px;
  color: #757575;
}
#details .product-select .isSelect {
  font-size: 19px;
  color: #E8A87C;
}
#details .product-select .notSelect:hover {
  color: #E8A87C;
}
#details .product-select .cut {
  font-size: 25px;
  color: #c9c7c7;
  margin-left: 35px;
  margin-right: 35px;
}
#details .product-img img {
  width: 1225px;
  display: block;
  margin: 0 auto;
}
/*商品概述&参数END*/

/*v-else*/
.not-found {
  height: 500px;
  text-align: center;
}
/*v-else END*/

/* 小屏适配 */
@media (max-width: 900px) {
  /* 顶部标题与快捷菜单不超出屏幕 */
  #details .page-header {
    height: auto;
    margin-top: 0;
  }
  #details .page-header .title {
    width: 100%;
    height: auto;
    padding: 8px 12px;
  }
  #details .page-header .title p {
    float: none;
    margin: 0 0 8px 0;
    line-height: 1.3;
  }
  #details .page-header .title .list {
    float: none;
    height: auto;
    display: flex;
    align-items: center;
    gap: 8px;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 6px;
  }
  #details .page-header .title .list .cut {
    flex: 0 0 auto;
  }

  /* 主体栈式布局 */
  #details .details-main {
    width: 100%;
    padding: 12px;
    border-bottom: 1px solid #e0e0e0;
  }
  #details .details-main .details-block,
  #details .details-main .details-content {
    float: none;
    width: 100%;
    margin: 0;
  }
  /* 轮播与图片高度（提升可视高度） */
  #details .details-main .details-block .el-carousel,
  #details .details-main .details-block .el-carousel__container {
    height: 560px !important;
  }
  #details .details-main .details-block img {
    height: 560px !important;
    width: 100%;
    object-fit: cover;
    border-radius: 8px;
  }

  /* 内容间距与按钮排版 */
  #details .details-main .details-content .view {
    float: none;
    padding-top: 4px;
    font-size: 14px;
  }
  #details .details-main .details-content .button {
    height: auto;
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    margin: 12px 0 16px;
  }
  #details .details-main .details-content .button .el-button {
    width: 100%;
    height: 46px;
    font-size: 15px;
  }
  #details .details-main .details-content .button .like {
    margin-left: 0;
  }

  /* 商品概述区域 */
  #details .product-select {
    width: 100%;
    height: auto;
    padding: 10px 12px;
    justify-content: center;
  }
  #details .product-img img {
    width: 100%;
  }
}
</style>
